<template>
  <div class="PhoneServiceMain">
    <div class="PhoneServiceMain__content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import 'bootstrap/dist/js/bootstrap.min.js'

export default {
  name: 'PhoneServiceMain',
}
</script>

<style lang="scss" scoped>
.PhoneServiceMain {
  &__content {
    min-height: calc(100vh - 30px);
    padding: 0 20px;
    padding-top: 10px;
  }
}

.footer {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &__text {
    margin: 0;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PhoneServiceMain.vue